/* @jsxImportSource react */

import type { ReactNode } from 'react';
import { type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn/cn';
import { statusChip } from './StatusChip.variants';

export type StatusChipProps = Pick<VariantProps<typeof statusChip>, 'color'> & {
  className?: string;
  children: ReactNode;
};

export const StatusChip = ({ className, color, children }: StatusChipProps) => (
  <div
    className={cn(
      statusChip({
        className,
        color,
      }),
    )}
  >
    {children}
  </div>
);

StatusChip.displayName = 'StatusChip';
